import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  CreateInvoiceSigningNote,
  CreateInvoiceSigningNoteVariables,
} from 'common/graphql/__generated__/CreateInvoiceSigningNote';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import ADD_NEW_NOTE from '../../../../../../graphql/NotePaymentCreate.graphql';

type NotesProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  invoiceId: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const Notes: React.FC<NotesProps> = ({
  invoiceId,
  data,
  loading,
  listRefreshRequest,
}) => {
  return (
    <GenericNotesSection<
      any,
      CreateInvoiceSigningNote, // TMutationResult (verify this type)
      CreateInvoiceSigningNoteVariables // TMutationVariables (verify this type)
    >
      entityId={invoiceId}
      data={data}
      loading={loading}
      mutationDocument={ADD_NEW_NOTE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
